import { Directive, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';
declare var google: any;

@Directive({
  selector: '[sflGooglePlaces]'
})
export class GooglePlacesDirective implements OnInit {
  @Output() addressSelect: EventEmitter<any> = new EventEmitter();
  private element: HTMLInputElement;

  constructor(private elRef: ElementRef) {
    this.element = elRef.nativeElement;
  }

  getFormattedAddress(place) {
    const location_obj = {};
    location_obj['add1'] = place.name;

    const location = place.geometry.location;
    location_obj['lat'] = location.lat();
    location_obj['lng'] = location.lng();
    location_obj['formatted_address'] = place.formatted_address;

    let locality_level_1 = null,
      locality_level_2 = null;
    place.address_components.map(addressComponent => {
      switch (addressComponent.types[0]) {
        case 'country':
          location_obj['country'] = addressComponent.long_name;
          break;
        case 'administrative_area_level_1':
          location_obj['state'] = addressComponent.long_name;
          break;
        case 'administrative_area_level_2':
          location_obj['city'] = addressComponent.long_name;
          break;
        case 'postal_code':
          location_obj['zipcode'] = addressComponent.long_name;
          break;
        case 'sublocality_level_2':
          locality_level_2 = addressComponent.long_name;
          break;
        case 'sublocality_level_1':
          locality_level_1 = addressComponent.long_name;
          break;
        case 'street_number':
          location_obj['add1'] = addressComponent.long_name;
          break;
        case 'route':
          location_obj['add1'] += ', ' + addressComponent.long_name;
          break;

        default:
          break;
      }
    });
    location_obj['add2'] = (locality_level_2 ? locality_level_2 : '') + (locality_level_2 ? ', ' : '') + (locality_level_1 ? locality_level_1 : '');

    return location_obj;
  }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(this.element);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.addressSelect.emit(this.getFormattedAddress(autocomplete.getPlace()));
    });
  }
}
